"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spell_anim = exports.spell_cursor = exports.getSpellData = void 0;
var spritesCursors_1 = require("@dive/spriteRecyclers/spritesCursors");
var spritesSpells_1 = require("@dive/spriteRecyclers/spritesSpells");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var key = 'lightning-cloud';
function getSpellData() {
    return {
        key: key,
        name: 'Lightning Cloud',
        desc: 'Hurl a large ball of fire, not recommended',
        castType: 'target',
        targetFinder: 'furthest',
    };
}
exports.getSpellData = getSpellData;
var spell_cursor = function (options) {
    // TODO: pass this off to the spell's cursor function
    var img = spritesCursors_1.spritesCursors.getNext(options.cursorTileX, options.cursorTileY, sprites_sidecar_1.sprites.diveEffectsCursorSpellTarget[0]);
    var radius = 2;
    var width = radius * 2;
    var halfWidth = Math.floor(width / 2);
    var height = radius * 2;
    var halfHeight = Math.floor(height / 2);
    for (var i = -halfWidth; i <= halfWidth; i++) {
        for (var j = -halfHeight; j <= halfHeight; j++) {
            var imgSpell = spritesCursors_1.spritesCursors.getNext(options.cursorTileX + i * diveTilemap_sidecar_1.diveTilemap.spotSize, options.cursorTileY + j * diveTilemap_sidecar_1.diveTilemap.spotSize, sprites_sidecar_1.sprites.diveEffectsWeeFxLightning1Png[0]);
            imgSpell.alpha = 0.5;
        }
    }
    return true;
};
exports.spell_cursor = spell_cursor;
function spell_anim(o) {
    var tickTime, radius, width, halfWidth, height, halfHeight, time, maxTime, delay, damage, rnd, isFlipped, _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tickTime = 0.1;
                radius = 2;
                width = radius * 2;
                halfWidth = Math.floor(width / 2);
                height = radius * 2;
                halfHeight = Math.floor(height / 2);
                time = 0;
                maxTime = Math.floor(5 * 10);
                delay = 2;
                damage = 50;
                rnd = randoInstanced_sidecar_1.randoInstanced.createRando(diveSimulationManager_sidecar_1.diveSimulationManager.getSyncedUnimportantRando().i(0, 999999999));
                isFlipped = false;
                _loop_1 = function () {
                    var i, j, doDamage, _b, x, y, img;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                i = rnd.intSymmetric(halfWidth) + o.startI;
                                j = rnd.intSymmetric(halfHeight) + o.startJ;
                                doDamage = function () {
                                    // Do damage
                                    var crewHere = diveCrew_sidecar_1.diveCrew.getAtIJ(i, j);
                                    if (crewHere) {
                                        if (crewHere.type === diveCrew_1.EVoyageCrewType.Enemy) {
                                            // TODO: damage effects?
                                            diveCrew_sidecar_1.diveCrew.hurt(crewHere, Math.floor(damage / 2), voyageMessageCrewHurt_1.EVoyageCrewDamageType.Fire, 0); // TODO: change damage type to lightning
                                        }
                                    }
                                };
                                _b = diveTilemap_sidecar_1.diveTilemap.convertIJtoXY(i, j), x = _b.x, y = _b.y;
                                img = spritesSpells_1.spritesSpells.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsWeeFxLightning1Png[0], tickTime * delay);
                                img.scaleX = isFlipped ? -img.scaleX : img.scaleX;
                                doDamage();
                                return [4 /*yield*/, { delay: delay }];
                            case 1:
                                _c.sent();
                                time += delay;
                                isFlipped = !isFlipped;
                                img = spritesSpells_1.spritesSpells.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsWeeFxLightning1Png[0], tickTime * delay);
                                img.scaleX = isFlipped ? -img.scaleX : img.scaleX;
                                doDamage();
                                return [4 /*yield*/, { delay: delay }];
                            case 2:
                                _c.sent();
                                time += delay;
                                isFlipped = !isFlipped;
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!(time < maxTime)) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
exports.spell_anim = spell_anim;
